import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { BillingRecurringTypes } from '../../models/ss-api/price.billing.cycle';
import { PublicOrderProductsResponseArray, PublicOrderProductsResponse } from '../../models/ss-api/responses/public.order.products.response';
import { Component, OnInit } from '@angular/core';

import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SelectItem } from 'primeng/api';
import { AddProductRequest } from 'app/models/ss-api/requests/add.product.request';
import { ssApiService } from 'app/services/ss-api.service';
import { CreditCardResponseArray } from 'app/models/ss-api/responses/credit.card.response';
import { GlobalServices } from '../../services/global.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MemberProfile } from 'app/models/domain/member.profile';

export interface IAddProductDialogModel {
  title: string;
  subTitle: string;
  CreditCards: SelectItem[];
  SelectedCreditCard: number;
  Products: PublicOrderProductsResponseArray;
  memberProfile?: MemberProfile
}

@Component({
  selector: 'add-product-dialog',
  styleUrls: ['./add-product-dialog.component.scss'],
  templateUrl: './add-product-dialog.component.html'
})
export class AddProductDialogComponent implements OnInit, IAddProductDialogModel {

  IsBusy: boolean = false;

  confirmTitle: string = 'Add Product';
  confirmMessage: string = 'You are about to purchase a new product subscription. Your credit card will be billed.';

  successTitle: string = 'Product added';
  successMessage: string = 'Your purchase was successfull. You will recieve an email with your new License Key.';

  errorTitle: string = 'Error';
  errorMessage: string = 'We were not able to process this request. Try again later or use a different credit card.';

  cancelledTitle: string = 'Cancelled';
  cancelledMessage: string = 'You cancelled this order.';


  AssignToOwner: boolean = false;
  Initials: string = '';
  title: string;
  subTitle: string;
  CreditCards: SelectItem[];
  SelectedCreditCard: number;
  Products: PublicOrderProductsResponseArray = new PublicOrderProductsResponseArray();
  memberProfile: MemberProfile;

  OrderForm: UntypedFormGroup;

  SelectedProduct: PublicOrderProductsResponse = new PublicOrderProductsResponse();
  SelectedBillingCycle: BillingRecurringTypes;
  SelectedPrice: number = 0;
  SelectedSetupFee: number = 0;

  PurchaseDisabled: boolean = true;
  ProductSelected: boolean = false;

  DesignerFieldsHidden: boolean = true;
  DesignerName: string;
  DesignerEmail: string;

  Credit: number = 3;

  PriceDue: number = 0;

  IsYardSelected: boolean = false;
  DisableYard: boolean = true;
  YardFee: number = 0;
  YardTax: number = 0;

  TaxEnabled: boolean = false;
  State: string = "";
  TaxRateDisplay: string = "";
  TaxAmount: number;
  TaxRate: number;

  AssignmentOptions: SelectItem[];
  KeyAssignment: SelectItem;

  result: any;

  currentModalStep: number = 1;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private api: ssApiService,
    private gb: GlobalServices
  ) {
  }

  ngOnInit(): void {
    this.title = this.config.data.title;
    this.subTitle = this.config.data.subTitle;
    this.CreditCards = this.config.data.CreditCards;
    this.Products = this.config.data.Products;
    this.SelectedCreditCard = this.config.data.SelectedCreditCard;
    this.memberProfile = this.config.data.memberProfile;

    this.AssignmentOptions = [
      { label: `Me: Only ${this.memberProfile.Firstname} ${this.memberProfile.Lastname} will have access`, value: 1 },
      { label: 'New Designer', value: 2 }
    ];
    this.KeyAssignment = this.AssignmentOptions[0];

    setTimeout(() => {
      let productID = Number(localStorage.getItem('cartProductID'));
      let billingCycle = Number(localStorage.getItem('cartBillingCycle'));
      let yard = Boolean(localStorage.getItem('cartHasYard'));

      if (productID && billingCycle) {
        let product = this.Products.filter(product => product.ProductID == productID)[0];
        this.SetSelectedProduct(product, billingCycle);
        this.SelectedBillingCycle = billingCycle;
        if (yard) {
          this.IsYardSelected = true;
        }
      } else {
        this.SetSelectedProduct(this.Products[0], BillingRecurringTypes.Monthly);
      }

      if (this.CreditCards) {
        this.SelectedCreditCard = this.CreditCards[0].value;
      }
    }, 500);

    this.GetCredit();

    this.OrderForm = new UntypedFormGroup({
      'confirmInitials': new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    });

  }

  YardAvailable(product: PublicOrderProductsResponse) {

    if (product.YardAddon == null || product.YardAddon == undefined)
      return false;

    var isDevPublic = this.gb.IsDevPublic();
    var isLocal = this.gb.IsLocal();

    //console.log("Item: ", product.Name);
    //console.log("YardVisiblePublic: ", product.YardVisiblePublic);
    //console.log("isDevPublic: ", isDevPublic);
    //console.log("isLocal: ", isLocal);

    if (!product.YardVisiblePublic && (!isDevPublic && !isLocal))
      return false;

    // ok
    return true;
  }

  close() {
    this.ref.close();
  }

  GetCredit() {
    this.IsBusy = true;

    let subscription = this.api.MemberCredit().subscribe(response => {
      subscription.unsubscribe();
      this.IsBusy = false;
      this.Credit = response.Data;
    }, error => {
      subscription.unsubscribe();
      this.IsBusy = false;
    });

  }

  CreditCardChanged(item: SelectItem) {

  }

  MonthlySelected(product: PublicOrderProductsResponse) {
    this.SetSelectedProduct(product, BillingRecurringTypes.Monthly);
  }

  YearlySelected(product: PublicOrderProductsResponse) {
    this.SetSelectedProduct(product, BillingRecurringTypes.Yearly);
  }

  SetSelectedProduct(product: PublicOrderProductsResponse, billingCycle: BillingRecurringTypes) {

    this.SelectedProduct = product;
    if (billingCycle) {
      this.SelectedBillingCycle = billingCycle;
    }
    this.SelectedPrice = product.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Price;
    this.SelectedSetupFee = product.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Setup;

    if (product.YardAddon != null && product.YardAddon != undefined && this.IsYardSelected)
      this.YardFee = product.YardAddon.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).Price;
    else
      this.YardFee = 0;

    console.log("selectedprod", this.SelectedProduct);
    this.TaxEnabled = this.SelectedProduct.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).TaxEnabled;
    this.TaxRateDisplay = this.SelectedProduct.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).TaxRateDisplay;
    this.State = this.SelectedProduct.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).State;
    this.TaxAmount = this.SelectedProduct.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).TaxAmount;

    this.TaxRate = this.SelectedProduct.Prices.find(x => x.BillingCycle == this.SelectedBillingCycle).TaxRate;
    this.TaxRate = this.TaxRate / 100;

    this.ProductSelected = true;

    this.YardTax = this.YardFee * this.TaxRate;
    this.YardTax = this.YardTax * 100;
    this.YardTax = Math.round(this.YardTax);
    this.YardTax = this.YardTax / 100;
    this.TaxAmount = this.TaxAmount + this.YardTax;

    this.PriceDue = this.SelectedPrice + this.SelectedSetupFee + this.YardFee + this.TaxAmount - this.Credit;
    if (this.PriceDue < 0)
      this.PriceDue = 0;

    this.CheckPurchaseDisabled();
  }

  billingCycleChange(e) {
    this.SelectedBillingCycle = e.checked ? BillingRecurringTypes.Yearly : BillingRecurringTypes.Monthly;
    this.SetSelectedProduct(this.SelectedProduct, this.SelectedBillingCycle);
  }

  AssignmentChanged(e) {
    this.KeyAssignment = this.AssignmentOptions.find(option => option.value === e.value);
    this.DesignerFieldsHidden = this.KeyAssignment.value != 2;
    if (this.DesignerFieldsHidden) {
      this.DesignerName = '';
      this.DesignerEmail = '';
      this.CheckPurchaseDisabled()
    }
  }

  YardSelected(event: any, product: PublicOrderProductsResponse) {

    this.IsYardSelected = event.checked;

  }



  InitialsChanged(data: string) {
    this.CheckPurchaseDisabled();
  }



  CheckDesignerFields() {
    if (this.DesignerFieldsHidden || (!this.DesignerFieldsHidden && (this.DesignerEmail != undefined && this.DesignerEmail.length > 1) && (this.DesignerName != undefined && this.DesignerName.length > 1))) {
      return true;
    } else {
      return false;
    }
  }

  CheckPurchaseDisabled() {
    if (this.ProductSelected && this.CreditCards.length > 0 && this.CheckDesignerFields()) {
      this.PurchaseDisabled = false;
    } else {
      this.PurchaseDisabled = true;
    }
  }

  IsBillingCycleSelected(product, cycle): boolean {
    if (this.SelectedBillingCycle == cycle && this.SelectedProduct.ProductID == product) {
      return true;
    }
    return false;
  }

  SelectedBillingCycleToString(): string {

    switch (this.SelectedBillingCycle) {

      case BillingRecurringTypes.Monthly:
        return 'month';

      case BillingRecurringTypes.Yearly:
        return 'year';

      default:
        return 'unimplemented';
    }

  }

  private PurchaseProduct(): Promise<any> {

    if (this.SelectedCreditCard == undefined)
      // we didn't change the credit card selection
      this.SelectedCreditCard = this.CreditCards[0].value;

    let request = new AddProductRequest();
    request.ProductID = this.SelectedProduct.ProductID;
    request.CreditCardID = Number(this.SelectedCreditCard);
    request.BillingCycle = this.SelectedBillingCycle;
    request.AssignToOwner = this.AssignToOwner;
    request.Initials = this.Initials;
    request.AdminID = this.gb.AdminID;
    request.YardAddon = this.IsYardSelected;

    if (!this.DesignerFieldsHidden) {
      if (this.DesignerEmail == '' && this.DesignerName == '') {
        Swal.fire({
          icon: 'warning',
          title: 'Missing Designer Information',
          text: 'Please fill in the Designer Name and Designer Email fields to purchase this license'
        });
        return;
      } else {
        request.DesignerEmail = this.DesignerEmail;
        request.DesignerName = this.DesignerName;
      }
    }

    return this.api.ProductsAdd(request)
      .toPromise()
      .then(response => {

        if (!response.Result)
          return response; // error

        this.result = response.Result;
        return response;
      });
  }

  ProcessOrder(): Promise<any> {
    // confirm

    return Swal.fire({
      title: this.confirmTitle,
      text: this.confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes, order!',
      cancelButtonText: 'No, cancel',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // try to order
        return this.PurchaseProduct();
      }
    });

  }

  async confirm() {

    await this.ProcessOrder()
      .then(
        (response: any) => {

          // init dialog vars
          let cType = 'success';
          let cTitle = this.successTitle;
          let cMessage = this.successMessage;

          if (response.isDismissed) {
            cType = 'error';
            cTitle = this.cancelledTitle;
            cMessage = this.cancelledMessage;
          } else if (!response.value || !response.value.Result) {
            // not ok
            cType = 'error';
            cTitle = this.errorTitle;
            cMessage = response.Data;
          }

          // show result
          Swal.fire(
            {
              title: cTitle,
              text: cMessage,
              icon: cType as SweetAlertIcon,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 10000
            })
            .then(() => { }, () => { }); // keep this line to prevent promise error;

        },
        (dismiss) => {
          if (dismiss === 'cancel') {

            if (!confirm)
              return;

            // show cancelled
            Swal.fire({
              title: this.cancelledTitle,
              text: this.cancelledMessage,
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000
            })
              .then(() => { }, () => { }); // keep this line to prevent promise error;
          }
        });

    this.gb.ClearOrderFormLocalStorage();

    this.result = true;
    this.close();
  }

  cancel() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.gb.ClearOrderFormLocalStorage();
    this.result = false;
    this.close();
  }

  next() {
    this.currentModalStep = 2;
  }

  back() {
    this.currentModalStep = 1;
  }

  showAddCreditCard: boolean = false;

  cardAdded({ cards, newCardId }: { cards: CreditCardResponseArray, newCardId: number }) {
    this.showAddCreditCard = false;
    this.updateCreditCardOptions(cards);
    this.SelectedCreditCard = newCardId;
    this.CheckPurchaseDisabled();
  }

  addCardCanceled() {
    this.showAddCreditCard = false;
  }

  updateCreditCardOptions(newCards: CreditCardResponseArray) {
    this.CreditCards = [];
    newCards.forEach(card => {
      this.CreditCards.push(
        {
          label: 'Name: ' + card.FirstName + ' ' + card.LastName +
            ' - Last four: ' + card.LastFour +
            ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
          value: card.ID
        });
    });
  }

  CreditUsed(): number {
    console.log("tta", this.TaxAmount);
    if (this.Credit > (this.SelectedPrice + this.SelectedSetupFee + this.YardFee + this.TaxAmount))
      return this.SelectedPrice + this.SelectedSetupFee + this.YardFee + this.TaxAmount;
    else
      return this.Credit;
  }

  getProductPrice(product) {
      

    try {
      var productPrice = product.Prices.find(price => price.BillingCycle === this.SelectedBillingCycle).Price;

      var yardPrice = 0;

      if (this.YardAvailable(product) && this.IsYardSelected)
        yardPrice = product.YardAddon.Prices.find(price => price.BillingCycle === this.SelectedBillingCycle).Price;

      return productPrice + yardPrice;
    } catch (e) {

    }
    return 0;
  }

}
